import React, { useEffect, useState } from "react";
import PaymentAccountInfo from "../../Member/PaymentAccountInfo";
import axiosInstance from "../../../hooks/axiosInstance";
import useAuth from "../../../hooks/useAuthContext";
import { toast } from "react-toastify";

const PayCashDues = ({ close, selectedDues, memberAccountInfo, allDues, refresh, transactionCharge }) => {
   const { userData } = useAuth();

   const paystackKey =  process.env.NODE_ENV !== 'production' ? 
                          process.env.REACT_APP_DEV_PAYSTACK_KEY :
                              process.env.REACT_APP_PROD_PAYSTACK_KEY;

  const [totalAmount, setTotalAmount] = useState(0);
  const [showAccount, setShowAccount] = useState(false)
  const [loading, setLoading] = useState(false);
  
  const sumFilteredAmounts = (items, allowedIds) => {
    return items.reduce((accumulator, currentObject) => {
        if (allowedIds.includes(currentObject.id) && currentObject.status == 'pending') {
            const amount = parseFloat(currentObject.association_dues.amount) || 0;
            return accumulator + amount;
        }
        
        return accumulator;
    }, 0); 
  };

  const createPaymentIntent = (type) => {
    setLoading(true)
    axiosInstance.post("/user/dues/payment-intent", {
      memberDueIds: selectedDues,
      payment_type: type,
      amount: totalAmount
    })
    .then(res => {
        if(type == 'paystack') {
            payWithPaystack(res.data.data.item.bulk_transaction_reference)
        } else {
            setShowAccount(true)
        }
    })
    .catch(err => console.log(err.response))
    .finally(() => setLoading(false))
  }

  const payWithPaystack = (transRef) => {
      var handler = window.PaystackPop.setup({
        key: paystackKey, // Replace with your public key
        email: userData?.userInfo?.email,
        amount: (totalAmount + transactionCharge) * 100, // the amount value is multiplied by 100 to convert to the lowest currency unit
        currency: 'NGN', // Use GHS for Ghana Cedis or USD for US Dollars
        ref: transRef, // Replace with a reference you generated
        callback: function(response) {
          //this happens after the payment is completed successfully
          paymentCallback(response); 
        },
        onClose: function() {
          alert('Transaction was not completed, window closed.');
        },
      });
      handler.openIframe();
  }

  const paymentCallback = async(response) => {
      const reference = response.reference;
      axiosInstance.post(`/user/dues/verify-payment`, {transRef: reference})
        .then(res  => {
            if(res.data.success){
                toast.success("Payment successful")
                close()
                refresh()
            }
        })
  }

  useEffect(() => {
    setTotalAmount(sumFilteredAmounts(allDues, selectedDues))
  }, [selectedDues])

  return (
    <div>
      <div className="mb-3">
          <h5 className="text-center">Make a payment of <b className="text-danger">₦{Number(totalAmount + transactionCharge).toLocaleString()}</b> using any of the payment methods below</h5>
      </div>
      <div className="mb-3 alert alert-info">
        <div className="d-flex justify-content-between">
          <div>
            <h6 className="mb-1">Amount</h6>
            <h4>₦{Number(totalAmount).toLocaleString()}</h4>
          </div>
          <div>
            <h6 className="mb-1">Charges</h6>
            <h4>₦{Number(transactionCharge).toLocaleString()}</h4>
          </div>
        </div>
      </div>
      <div
        className="accordion custom-accordionwithicon custom-accordion-border accordion-border-box accordion-secondary"
        id="accordionBordered"
      >
        <div className="accordion-item">
          <h2 className="accordion-header" id="accordionborderedExample1">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accor_borderedExamplecollapse1"
              aria-expanded="true"
              aria-controls="accor_borderedExamplecollapse1"
            >
              <i className="ri-secure-payment-line me-2"></i> Paystack
            </button>
          </h2>
          <div
            id="accor_borderedExamplecollapse1"
            className="accordion-collapse collapse show"
            aria-labelledby="accordionborderedExample1"
            data-bs-parent="#accordionBordered"
          >
            <div className="accordion-body">
              <div className="text-center">
                <button type="button" className="btn btn-success btn-label waves-effect waves-light" onClick={() => createPaymentIntent('paystack')} disabled={loading}>
                    <i className="ri-check-double-line label-icon align-middle fs-16 me-2"></i>  Pay with Paystack
                    {loading && <div className="spinner-border spinner-border-sm text-light align-middle fs-16 mx-2"></div>}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="accordion-item mt-2">
          <h2 className="accordion-header" id="accordionborderedExample2">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accor_borderedExamplecollapse2"
              aria-expanded="false"
              aria-controls="accor_borderedExamplecollapse2"
            >
            <i className="ri-smartphone-line me-2"></i> Bank Transfer
            </button>
          </h2>
          <div
            id="accor_borderedExamplecollapse2"
            className="accordion-collapse collapse"
            aria-labelledby="accordionborderedExample2"
            data-bs-parent="#accordionBordered"
          >
            <div className="accordion-body">
                {showAccount ?
                    <PaymentAccountInfo memberAccountInfo={memberAccountInfo} />
                :
                    <div className="text-center">
                        <button type="button" className="btn btn-primary btn-label waves-effect waves-light" onClick={() => createPaymentIntent('transfer')} disabled={loading}>
                            <i className="ri-check-double-line label-icon align-middle fs-16 me-2"></i>  Pay with Transfer
                            {loading && <div className="spinner-border spinner-border-sm text-light align-middle fs-16 mx-2"></div>}
                        </button>
                    </div>
                }
            </div>
          </div>
        </div> */}
        {/* <div className="accordion-item mt-2">
          <h2 className="accordion-header" id="accordionborderedExample3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accor_borderedExamplecollapse3"
              aria-expanded="false"
              aria-controls="accor_borderedExamplecollapse3"
            >
              Where does it come from ?
            </button>
          </h2>
          <div
            id="accor_borderedExamplecollapse3"
            className="accordion-collapse collapse"
            aria-labelledby="accordionborderedExample3"
            data-bs-parent="#accordionBordered"
          >
            <div className="accordion-body">
              Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante
              ipsum primis in faucibus orci luctus et ultrices posuere cubilia
              Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis
              et arcu arcu tortor, suscipit eget, imperdiet nec, imperdiet
              iaculis aliquam ultrices mauris.
            </div>
          </div>
        </div> */}
      </div>
      <div className="mt-4">
        <div className="hstack gap-2 justify-content-end">
          <button type="button" className="btn btn-light" onClick={close}>
            Close
          </button>
          {/* <button type="submit" className="btn btn-success" id="add-btn">
            Submit
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default PayCashDues;
